import { render, staticRenderFns } from "./back-bar.vue?vue&type=template&id=d6798664&scoped=true"
import script from "./back-bar.vue?vue&type=script&lang=js"
export * from "./back-bar.vue?vue&type=script&lang=js"
import style0 from "./back-bar.vue?vue&type=style&index=0&id=d6798664&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6798664",
  null
  
)

export default component.exports